import { Routes, Route, Navigate } from 'react-router-dom';
import {AuthRoute} from '../components/routing/AuthRoute';
import {ProtectedRoute} from '../components/routing/ProtectedRoute';
import Profile from '../components/Profile';
import ProfileSettings from '../components/ProfileSettings';
import Login from '../components/auth/Login';
import EnhancedChatApp from '../pages/EnhancedChatApp';
import { useAuth } from '@/contexts/AuthContext';
import { getAuth } from 'firebase/auth';
import SubscriptionManagement from '../pages/SubscriptionManagement';
import PaymentHistory from '../pages/PaymentHistory';


// Authentication Components
import SignUp from '../components/auth/SignUp';
import ForgotPassword from '../components/auth/ForgotPassword';
import VerifyEmail from '../components/auth/VerifyEmail';

// Core Components
import Settings from '../components/Settings';

// Legal Components
import Terms from '../components/legal/TermsOfService';
import Privacy from '../components/legal/PrivacyPolicy';

// Profile and Onboarding Flow
import ProfileFlow from '../components/routing/ProfileFlow';
import OnboardingTracker from '../components/Onboarding';

// Profile and Onboarding Flow
import CertificatesSection from '../components/profile/certificates/CertificatesSection';
import Medical from '../components/profile/Medical';
import Aircraft from '../components/profile/Aircraft';
import FlightHistory from '../components/profile/FlightHistory';

const AppRoutes = () => {

  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/login" element={<AuthRoute><Login /></AuthRoute>} />
      <Route path="/signup" element={<AuthRoute><SignUp /></AuthRoute>} />
      <Route path="/forgot-password" element={<AuthRoute><ForgotPassword /></AuthRoute>} />
      <Route path="/verify-email" element={<AuthRoute><VerifyEmail /></AuthRoute>} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />

      {/* Protected Routes */}
      <Route path="/" element={<ProtectedRoute><Navigate to="/chat" replace /></ProtectedRoute>} />
      <Route path="/chat" element={<ProtectedRoute><EnhancedChatApp /></ProtectedRoute>} />
            
      {/* Other Protected Routes */}
      <Route path="/profile/*" element={<ProtectedRoute><ProfileFlow /></ProtectedRoute>}>
        <Route index element={<OnboardingTracker />} />
        <Route path="aircraft" element={<OnboardingTracker />} />
        <Route path="experience" element={<OnboardingTracker />} />
        <Route path="certificates" element={<OnboardingTracker />} />
        <Route path="ratings" element={<OnboardingTracker />} />
        <Route path="documents" element={<OnboardingTracker />} />
      </Route>
      <Route path="/subscription" element={<ProtectedRoute><SubscriptionManagement /></ProtectedRoute>} />
      <Route path="/payment-history" element={<ProtectedRoute><PaymentHistory /></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
      
      {/* Onboarding Flow */}
      <Route path="/onboarding/*" element={<ProfileFlow />} />

      {/* Profile routes */}
      <Route path="/profile" element={<Profile />}>
        <Route path="settings" element={<ProfileSettings />} />
        <Route path="licenses" element={<CertificatesSection />} />
        <Route path="medical" element={<Medical />} />
        <Route path="aircraft" element={<Aircraft />} />
        <Route path="history" element={<FlightHistory />} />
      </Route>

      {/* Catch-all route */}
      <Route path="*" element={<ProtectedRoute><Navigate to="/chat" replace /></ProtectedRoute>} />
    </Routes>
  );
};

export default AppRoutes;